import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import SafeIcon from './SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { LOGO_BUG_URL } from '../../constants/brand';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-gray-900 text-white py-12 border-t border-gray-800">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2">
              <img src={LOGO_BUG_URL} alt="" className="h-10 w-10 object-contain flex-shrink-0" aria-hidden />
              <span className="font-bold text-2xl text-white">Mujeres y Riquezas</span>
            </div>
            <p className="text-gray-400 mt-4 text-sm">Empowering financial freedom.</p>
          </div>

          <div className="col-span-1">
            <h4 className="font-bold mb-4 text-pink-500">Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/" className="hover:text-white">Inicio</a></li>
              <li><a href="#about" className="hover:text-white">Sobre Jenny</a></li>
              <li><a href="#resources" className="hover:text-white">Recursos</a></li>
              <li><a href="/social" className="hover:text-white">Social</a></li>
            </ul>
          </div>

          <div className="col-span-1">
            <h4 className="font-bold mb-4 text-pink-500">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white">Terms of Service</a></li>
            </ul>
          </div>

          <div className="col-span-1">
            <h4 className="font-bold mb-4 text-pink-500">Connect</h4>
            <div className="flex gap-4">
              {[
                { icon: FiIcons.FiInstagram, href: 'https://instagram.com/mujeresyriquezas', label: 'Instagram' },
                { icon: FiIcons.FiFacebook, href: 'https://facebook.com/mujeresyriquezas', label: 'Facebook' },
                { icon: FiIcons.FiLinkedin, href: 'https://linkedin.com/in/prosperityleaders', label: 'LinkedIn' }
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.label}
                  className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-pink-600 transition-colors"
                >
                  <SafeIcon icon={item.icon} />
                </a>
              ))}
            </div>
            <a href="/admin" className="text-xs text-gray-700 mt-4 block hover:text-gray-500">Admin Login</a>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Mujeres y Riquezas. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;